<div class="modal inmodal fade in show detailed-view-body property-modal">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">
                            {{isEditMode ? 'Edit' : 'New'}} {{tabId === 'propertyGroup' ? 'Corporation' : 'Property'}}
                        </h4>

                        <div class="input-group-btn pull-right">
                            <button class="btn btn-primary submit" type="submit" [disabled]="disabledSubmit">
                                Save
                            </button>

                            <button data-toggle="dropdown"
                                    class="btn btn-primary dropdown-toggle"
                                    type="button"
                                    aria-expanded="false">
                                <span class="caret"></span>
                            </button>

                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="close(form)">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="modal-body" [ngStyle]="{'overflow' : tabId === 'propertyGroup' ? 'inherit' : 'auto'}">
                    <div class="m-b-sm">
                        <div class="row m-b-xs">
                            <div class="dv-label strong col-sm-3" data-toggle="tooltip" data-placement="top">
                                Name
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <input [ngModel]="data.name"
                                       name="name"
                                       class="form-control"
                                       maxlength="255"
                                       required
                                       autocomplete="off">
                            </div>
                        </div>
                    </div>

                    <div class="m-b-sm">
                        <contact-field *ngIf="isUserAdmin() && tabId === 'property'"
                                       id="contactField"
                                       name="contacts"
                                       [title]="'Contacts:'"
                                       (reset)="resetPhones($event)"
                                       (ngModelChange)="onContactChanged($event)"
                                       [ngModel]="data.contacts">
                        </contact-field>
                    </div>

                    <div class="m-b-sm">
                        <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'property'">
                            <div class="dv-label strong col-sm-3" data-toggle="tooltip" data-placement="top">
                                Address
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <input [ngModel]="data.address"
                                       name="address"
                                       id="address"
                                       class="form-control"
                                       maxlength="255"
                                       autocomplete="off"
                                       (input)="addressValueChanged.next($event.target.value)"
                                       [matAutocomplete]="addressList">
                                <mat-autocomplete #addressList="matAutocomplete"
                                                  (optionSelected)="changeAutocompleteValue($event)">
                                    <mat-option *ngFor="let address of addressSuggestions" [value]="address">
                                        {{ address.formatted_address }}
                                    </mat-option>
                                </mat-autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="m-b-sm">
                        <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'property'">
                            <div class="dv-label strong col-sm-3" data-toggle="tooltip" data-placement="top">
                                Postal Code
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <input [ngModel]="data.postalCode"
                                       name="postalCode"
                                       class="form-control"
                                       maxlength="255"
                                       autocomplete="off">
                            </div>
                        </div>
                    </div>

                    <div class="m-b-sm">
                        <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'property'">
                            <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                                Corporation #
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <ng-select
                                    [items]="foundCorporationNumbers | async"
                                    [ngModel]="data.corporationNumber"
                                    [loading]="loadingCorporations"
                                    [typeahead]="corporationNumberSearchSubject"
                                    name="corporationNumber"
                                    bindLabel="optionText"
                                    bindValue="value"
                                    class="mcc mcc-sm"
                                    style="width: 100%"
                                >
                                </ng-select>
<!--                                <select class="form-control" name="corporationNumber"-->
<!--                                        [disabled]="propertyService.corporationNumberList.length < 1"-->
<!--                                        [ngModel]="data.corporationNumber">-->
<!--                                    <option *ngFor="let corporation of propertyService.corporationNumberList"-->
<!--                                            [value]="corporation.id">-->
<!--                                        {{ corporation.name }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                                <spinner [spinnerShow]="propertyService.corporationNumberList.length < 1"></spinner>-->
                            </div>
                        </div>
                    </div>

                    <div class="m-b-sm">
                        <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'property'">
                            <div class="dv-label strong col-sm-3" data-toggle="tooltip" data-placement="top">
                                Property Type
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <input [ngModel]="data.propertyType"
                                       name="propertyType"
                                       class="form-control"
                                       maxlength="255"
                                       autocomplete="off">
                            </div>
                        </div>
                    </div>

                    <div class="m-b-sm">
                        <div class="row m-b-xs" *ngIf="isUserAdmin()">
                            <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                                Property Mgmt
                            </div>

                            <div class="dv-value-edit col-sm-9">
                                <select class="form-control" name="companyId" [ngModel]="data.companyId">
                                    <option *ngFor="let company of propertyService.companies"
                                            [value]="company.id">
                                        {{ company.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'property'">
                        <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                            Timezone
                        </div>

                        <div class="dv-value-edit col-sm-9">
                            <select class="form-control" name="timeZone" [ngModel]="'193'" required>
                                <option *ngFor="let timezone of propertyService.timezoneList"
                                        [value]="timezone.id">
                                    {{ timezone.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row m-b-xs" *ngIf="isUserAdmin() && tabId === 'propertyGroup'">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip" title="">
                            Buildings
                        </div>
                        <div class="dv-value-edit col-sm-9">
                            <ng-multiselect-dropdown class="multiselect-dropdown"
                                                     [placeholder]="'Select buildings'"
                                                     [data]="propertyService.buildingsList"
                                                     [(ngModel)]="propertyService.selectedBuildings"
                                                     name="buildings"
                                                     [settings]="dropdownSettings"
                                                     (onSelect)="onItemSelect($event)"
                                                     (onSelectAll)="onSelectAll($event)">
                            </ng-multiselect-dropdown>
                            <spinner [spinnerShow]="propertyService.buildingsList.length < 1"></spinner>
                        </div>
                    </div>

                    <div class="m-t-sm" *ngIf="isUserAdmin() && tabId === 'property'">
                        <agm-map [latitude]="data.latitude || 43.653226"
                                 [longitude]="data.longitude || -79.3831843"
                                 [zoom]="13"
                                 [fullscreenControl]="false"
                                 [streetViewControl]="false"
                                 (mapClick)="placeMarker($event)" (mapDblClick)="mapDblClick()">
                            <agm-marker [latitude]="data.latitude" [longitude]="data.longitude"></agm-marker>
                        </agm-map>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal-backdrop fade in" (click)="close(form)"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property-modal/property-modal.component.html